export const JOB_STATUS_QUEUED = 'queued';
export const JOB_STATUS_RUNNING = 'running';
export const JOB_STATUS_COMPLETE = 'completed';
export const JOB_STATUS_ERROR = 'failed';
export const JOB_STATUS_CANCELED = 'canceled';
export const JOB_STATUS_TERMINATED = 'terminated';
export const JOB_STATUS_ABANDONED = 'abandoned';

export const JOB_STEP_STATUS_QUEUED = 'queued';
export const JOB_STEP_STATUS_DEQUEUED = 'dequeued';
export const JOB_STEP_STATUS_RUNNING = 'running';
export const JOB_STEP_STATUS_COMPLETE = 'completed';
export const JOB_STEP_STATUS_ERROR = 'failed';
export const JOB_STEP_STATUS_SKIPPED = 'skipped';
export const JOB_STEP_STATUS_TERMINATED = 'terminated';
export const JOB_STEP_STATUS_ABANDONED = 'abandoned';
export const JOB_STEP_STATUS_CANCELED = 'canceled';

export const SEND_GRID_DELIVERED = 'delivered';
export const ZERO_BOUNCE_VALID = 'valid';

export const EmailStatuses = {
  mailboxNotFound: 'MailboxNotFound',
  doesNotAcceptMail: 'MailboxDoesNotAcceptMail',
  noDnsEntries: 'NoDnsEntriesFound',
  bounce: 'bounce',
  dropped: 'dropped',
  invalid: 'Invalid',
  full: 'Recipient List over Package Quota',
  spam1: 'Spam Reporting Address',
  spam2: 'Spam Content',
  unsubscribed: 'Unsubscribed Address'
};

export const ESignatureTypes = {
  signature: 'signature',
  initials: 'initials'
};

export const BasicElementTypes = {
  Image: 0,
  Text: 1,
  Rectangle: 2,
  Line: 3,
  Triangle: 4,
  Cirlce: 5,
  Table: 6,
  Checkbox: 7,
  Radio: 8
};

// todo - convert to enum
export const FieldTypes = {
  TextBox: 0,
  DropDown: 1,
  TextArea: 3,
  Signature: 4,
  CheckBox: 5,
  FileAttachment: 6,
  DateTime: 7,
  Date: 8,
  Time: 9,
  Image: 10,
  CheckBoxGroup: 11,
  Table: 12,
  Sketch: 13,
  Number: 14,
  Database: 15,
  GPS: 16,
  AutoNumber: 17,
  Barcode: 18,
  eSignature: 19,
  eSignatureInitials: 20,
  Audio: 21
};

export function GetDisplayNameForFieldType(fieldType: number) {
  switch (fieldType) {
    case FieldTypes.TextBox:
    case FieldTypes.TextArea:
      return 'Text';
    case FieldTypes.DropDown:
      return 'Drop Down';
    case FieldTypes.Signature:
      return 'Signature';
    case FieldTypes.CheckBox:
      return 'Check Box';
    case FieldTypes.DateTime:
      return 'Date Time';
    case FieldTypes.Date:
      return 'Date';
    case FieldTypes.Time:
      return 'Time';
    case FieldTypes.Image:
      return 'Image';
    case FieldTypes.CheckBoxGroup:
      return 'Check Box Group';
    case FieldTypes.Table:
      return 'Table';
    case FieldTypes.Sketch:
      return 'Sketch';
    case FieldTypes.Number:
      return 'Number';
    case FieldTypes.Database:
      return 'Database';
    case FieldTypes.GPS:
      return 'Location';
    case FieldTypes.AutoNumber:
      return 'Auto Number';
    case FieldTypes.Barcode:
      return 'Barcode';
    case FieldTypes.eSignature:
      return 'eSign Signature';
    case FieldTypes.eSignatureInitials:
      return 'eSign Initials';
    case FieldTypes.FileAttachment:
      return 'File Attachment';
    case FieldTypes.Audio:
      return 'Audio';
    default:
      return null;
  }
}

export function GetDisplayNameForBasicElement(basicElementType: number) {
  switch (basicElementType) {
    case BasicElementTypes.Image:
      return 'Image';
    case BasicElementTypes.Text:
      return 'Text';
    case BasicElementTypes.Rectangle:
      return 'Rectangle';
    case BasicElementTypes.Line:
      return 'Line';
    case BasicElementTypes.Triangle:
      return 'Triangle';
    case BasicElementTypes.Cirlce:
      return 'Circle';
    case BasicElementTypes.Table:
      return 'Table';
    case BasicElementTypes.Checkbox:
      return 'Checkbox';
    case BasicElementTypes.Radio:
      return 'Radio';
    default:
      return null;
  }
}

export const DisplayType = {
  String: 0,
  Checkmark: 1,
  Xmark: 2,
  Circle: 3,
  Oval: 4,
  FilledOval: 5,
  GPSMap: 0,
  GPSText: 1,
  Barcode: 0,
  BarcodeText: 1
};

export const AccordionTypes = {
  AddNewFields: 1,
  TemplateFields: 2
};

export const TemplateActionTypes = {
  WebView: 0,
  DeepLink: 1,
  WorkflowTrigger: 2,
  HpMeasure: 3
};

export const FormulaBarMode = {
  Formula: 0,
  Text: 1
};

export const ExternalDataSources = {
  AccountUserList: 'Account User List'
};

export enum PropertyTypes {
  Number = 'number',
  Integer = 'integer',
  Bool = 'bool',
  Select = 'select',
  DataSource = 'dataSource',
  DisplayColumn = 'displayColumn',
  Label = 'label',
  Color = 'color',
  Calculation = 'calculation',
  DefaultValues = 'defaultValues',
  TableColumns = 'tableColumns',
  CheckBoxGroupItems = 'checkBoxGroupItems',
  PositionItems = 'positionItems',
  DropDownItems = 'dropDownItems',
  Formatting = 'formatting',
  ValidationAddition = 'validationAddition',
  Filetypes = 'filetypes',
  Text = 'text',
  BasicElementsDash = 'basicElementsDash',
  BasicElementFontFormatting = 'basicElementFontFormatting',
  BasicElementGroupAlign = 'basicElementGroupAlign',
  BasicElementImageSelector = 'basicElementImageSelector',
  BasicElementLocked = 'basicElementLocked',
  BasicElementPrimaryActions = 'basicElementPrimaryActions',
  BasicElementTextAlign = 'basicElementTextAlign',
  BasicElementXYSync = 'basicElementXYSync',
  BasicElementZIndex = 'basicElementZIndex',
  ValidationSettings = 'validationSettings',
  FormJourneySelect = 'formJourneySelect',
  FormJourneyRecipient = 'formJourneyRecipient',
  FormJourneyBranches = 'formJourneyBranches'
}

export enum DataSourceOrigin {
  Client = 'Client',
  External = 'External'
}

export enum EntityTypes {
  BasicElement = 'basicElement',
  Column = 'column',
  ColumnPosition = 'columnPosition',
  DataLayoutPosition = 'dataLayoutPosition',
  DataLayoutSection = 'dataLayoutSection',
  DataLayoutTab = 'dataLayoutTab',
  Field = 'field',
  FieldPosition = 'fieldPosition',
  JourneyNode = 'journeyNode',
  RowPosition = 'rowPosition',
  Page = 'page',
  Validation = 'validation'
}

export enum TemplateFileTypes {
  Image = 'Image'
}

export enum BasicElementActionTypes {
  AddImage = 'AddImage',
  Delete = 'Delete',
  GroupAlign = 'GroupAlign',
  ZIndex = 'ZIndex'
}

export enum BasicElementComputedProperties {
  Width = 'ComputedWidth',
  Height = 'ComputedHeight'
}

export enum BasicElementZIndexAction {
  SendToFront = 'sendToFront',
  SendForward = 'SendForward',
  SendToBack = 'sendToBack',
  SendBackward = 'sendBackward'
}

export enum BasicElementGroupAlignAction {
  GroupAlignLeft = 'groupAlignLeft',
  GroupAlignMiddle = 'groupAlignMiddle',
  GroupAlignRight = 'groupAlignRight',
  GroupAlignBottom = 'groupAlignBottom',
  GroupAlignCenter = 'groupAlignCenter',
  GroupAlignTop = 'groupAlignTop'
}

export enum EditorTypes {
  PageEditor = 'PageEditor',
  FieldEditor = 'FieldEditor',
  JourneyEditor = 'JourneyEditor',
  FormsList = 'FormsList',
  WorkflowsList = 'WorkflowsList'
}

export enum Keys {
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  ArrowUp = 'ArrowUp',
  Backspace = 'Backspace',
  Delete = 'Delete',
  Enter = 'Enter',
  C = 'c',
  V = 'v',
  Y = 'y',
  Z = 'z'
}

export enum SubscriptionCodes {
  Basic = 'gf-basic',
  Trial = 'gf-trial',
  Teacher = 'gf-teacher',
  Team = 'gf-team',
  Advanced = 'gf-advanced',
  Enterprise = 'gf-enterprise'
}

export enum PaymentType {
  PayPal = 'PayPal',
  CreditCard = 'CreditCard',
  ExistingCreditCard = 'ExistingCreditCard'
}

export const DEFAULT_BORDER_COLOR = '#b6c1c6';
export const RUSTY_RED = '#D11926';
export const SUNGLOW = '#F7DA61';

export const formActionMenuItemTooltips = {
  transfer: 'You can only transfer or update a Form draft you own. If you want to transfer this Form, you’ll need to reopen it or take ownership of it.'
};

export const validationSettingsDefaultDisplayMessage = 'This message will display to guide your form user.';

export const deviceTypes = [
  {
    key: 'Desktop',
    text: 'Desktop',
    value: 'desktop'
  },
  {
    key: 'Tablet',
    text: 'Tablet',
    value: 'tablet'
  },
  {
    key: 'Phone',
    text: 'Phone',
    value: 'phone'
  }
];

export enum JourneyNodeType {
  Start = 'start',
  Transfer = 'transfer',
  Send = 'send',
  Approval = 'approval',
  Branch = 'branch',
  End = 'end'
}
